import router from "./router";
import store from "./store";
import { getUserInfo } from "./api/login";
import Cookies from "js-cookie";
import { addUrlPerFix } from "@/utils";

// let agentId = 100108;
let timer;
router.beforeEach(async (to, from, next) => {
  // 获取AppToken start
  // 开发环境加localhost加临时access_token防止无限重定向登录
  if (process.env.NODE_ENV === "development") {
    // Cookies.set("access_token", "5c65ecd672044a61a42862bed22525e3");
  }

  function goLogin() {
    window.location.href =
      addUrlPerFix(process.env.VUE_APP_LOGIN) +
      "?redirectUrl=" +
      encodeURIComponent(window.location.href);
  }
  function getTimer() {
    return setInterval(function() {
      if (!Cookies.get("access_token")) {
        goLogin();
      }
    }, 1000);
  }
  if (Cookies.get("access_token")) {
    store.commit("SET_ACCESS_TOKEN", Cookies.get("temp-token"));
    timer = timer || getTimer();
    // if (to.query.CODE) {
    //   if (localStorage.appToken === undefined) {
    //     let res = await getAppToken({
    //       code: to.query.CODE,
    //       client_id: agentId
    //     });
    //     if (res.data.code === "0") {
    //       // 缓存apptoken
    //       localStorage.appToken = res.data.message;
    //       store.commit("SET_APP_TOKEN", localStorage.appToken);
    //     } else if (res.data.code === "111") {
    //       // 失效时删除缓存的apptoken和accessToken
    //       localStorage.removeItem("appToken");
    //       goLogin();
    //     } else if (res.data.code === "305" || res.data.code === "307") {
    //       // 无权限（agentId是错的305—）或没有agentId307
    //       counter++;
    //       store.dispatch("setRouter305", {
    //         isShow: true,
    //         message: res.data.message
    //       });
    //       next({
    //         replace: true,
    //         path: "/305"
    //       });
    //       return;
    //     }
    //   } else {
    //     store.commit("SET_APP_TOKEN", localStorage.appToken);
    //   }
    // } else {
    //   if (localStorage.appToken === undefined) {
    //     // 走OAuth流程
    //     if (counter === 0) {
    //       window.location.href =
    //         addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
    //         "?CLIENT_ID=" +
    //         agentId +
    //         "&CALLBACK_URL=" +
    //         encodeURIComponent(window.location.href + "?");
    //     }
    //   } else {
    //     store.commit("SET_APP_TOKEN", localStorage.appToken);
    //   }
    // }
  } else {
    // Cookies里也没有ACCESS_TOKEN,跳登录页
    goLogin();
  }
  // 获取AppToken end

  if (store.state.app.routerPower.isShow) {
    next();
    return;
  }

  if (sessionStorage.getItem("userInfo")) {
    const baseAppId = JSON.parse(sessionStorage.getItem("userInfo")).appId;
    await store.dispatch("setAppId", baseAppId);
  } else {
    // {"userName":"游欢欢","loginName":"15601236723","userId":"100002@100001","orgName":"电子商务事业部运营中心","orgId":"2","appId":100002,"appName":"电子商城"}
    const res = await getUserInfo({});
    if (res.data.code === "0") {
      window.returnUrl = res.data.data.returnUrl;
      const obj = {};
      const userInfo = res.data.data.userInfo;
      const organizations = res.data.data.organizations;
      obj.userName = userInfo.userName;
      if (organizations && organizations.length) {
        obj.orgName = organizations[0].appList[0].orgName;
        obj.appId = organizations[0].appList[0].appId;
      }

      // sessionStorage.setItem("userInfo", JSON.stringify(obj));
      // await store.dispatch("setAppId", obj.appId);
    }
  }

  // return resMunuObj;
  // console.log(222222222);

  if (to.name) {
    // 是否隐藏三级菜单
    if (to.meta.isShowSidebar) {
      store.dispatch("openSidebarTemporary");
    } else {
      store.dispatch("closeSidebarTemporary");
    }
  }

  next();
});
